import { IProject } from 'shared/interfaces'

export const useLocalProjectFlags = (project: IProject) => {
  const isGlobalizing = project?.parent?.global_status === 'PREPARING'
  const isGlobalized = project?.parent?.global_status === 'PUBLISHED'
  const isOriginal = isGlobalized && project?.original_campaign_id === project.id
  const isLocalized = isGlobalized && project?.original_campaign_id !== project.id

  return {
    isLocalized,
    isOriginal,
    isGlobalizing,
    isGlobalized
  }
}
